import * as React from 'react'
import cx from 'classnames'
import styles from './SplitView.sass'

interface SplitViewProps {
  children?: React.ReactNode
  flexChild?: boolean
}

/**
 " Split View
 */
export function SplitView({ children, flexChild }: SplitViewProps) {
  return (
    <div className={cx(styles.root, flexChild && styles.flexChild)}>
      {children}
    </div>
  )
}

interface SplitViewSideProps extends React.RefAttributes<HTMLDivElement> {
  children?: React.ReactNode
  collapsed?: boolean
  highlightBorder?: boolean
  narrow?: boolean
}

/**
 * Split View Side
 */
export function SplitViewSide({
  children,
  collapsed,
  highlightBorder,
  narrow,
}: SplitViewSideProps) {
  return (
    <div
      className={cx(
        styles.side,
        collapsed && styles.collapsed,
        highlightBorder && styles.highlightBorder,
        narrow && styles.narrow,
      )}
    >
      {children}
    </div>
  )
}

interface SplitViewMainProps extends React.RefAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

/**
 " Split View Main
 */
export const SplitViewMain = React.forwardRef(function SplitViewMain(
  { children }: SplitViewMainProps,
  ref: React.Ref<HTMLDivElement>,
) {
  return (
    <div ref={ref} className={styles.main}>
      {children}
    </div>
  )
})
